import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { LOGIN } from '../utils/mutations';
import { LOGGED_IN_USER } from '../utils/actions';
import Auth from '../utils/auth';

function Login(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formState, setFormState] = useState({ email: '', password: '' });
  const [login, { error: loginError }] = useMutation(LOGIN);

  // const [testMut, { error: testMutError }] = useMutation(TEST_MUTATION);

  // const runTestMut = () => {
  //   testMut().then(r => console.debug(r));
  // }

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    try {
      login(
        {
          variables: formState,
          fetchPolicy: 'no-cache'
        })
        .then( ({data: {login: {token, user}}}) => {
            Auth.setToken(token);
            dispatch({ type: LOGGED_IN_USER, user });
            return navigate('/');
        });
    }
    catch (e) {
      console.log(e);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  return (
    <div className="container my-1">
      <Link to="/signup">← Go to Signup</Link>

      <h2>Login</h2>
      <form onSubmit={handleFormSubmit}>
        <div className="flex-row space-between my-2">
          <label htmlFor="email">Email address:</label>
          <input
            placeholder="Enter your email"
            name="email"
            type="email"
            id="email"
            onChange={handleChange}
            autoComplete="username"
          />
        </div>
        <div className="flex-row space-between my-2">
          <label htmlFor="pwd">Password:</label>
          <input
            placeholder="Enter password"
            name="password"
            type="password"
            id="pwd"
            onChange={handleChange}
            autoComplete="current-password"
          />
        </div>
        {loginError ? (
          <div>
            <p className="error-text">Either email or password was not correct, please try again</p>
          </div>
        ) : null}
        <div className="flex-row flex-end">
          <button type="submit" disabled={! formState.email.includes("@") || formState.password === ''} >Login</button>
        </div>
      </form>
    </div>
  );
}

export default Login;